export const PermissionHome = {
    PUT: "home-PUT",
    POST: "home-POST",
    DELETE: "home-DELETE",
    GET: "home-GET",
    GET_UUID: "home-by-customer-GET"
};